<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <AppAddUpdateModal :id="id" :title="(clientToEdit ? $t($getConst.pages.client.update_new_client):$t($getConst.pages.client.add_new_client)) | capitalize">
    <template v-slot:form>
      <ClientForm :modal_id="id" :clientToEdit="clientToEdit"/>
    </template>
  </AppAddUpdateModal>
</template>

<script>
  import ClientForm from "./ClientForm";
  import AppAddUpdateModal from "../../components/common/modals/AppAddUpdateModal";
  export default {
    name: "ClientModal",
    components: {ClientForm, AppAddUpdateModal},
    props: {
      id: null,
      clientToEdit: null,
    }
  }
</script>

<style scoped>

</style>
